const GoogleMap = () => {
  // Saint-Bruno-de-Montarville coordinates for the clinic address
  const mapSrc = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2799.5!2d-73.3517!3d45.5333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc904e1e1e1e1e1%3A0x0!2s1501%20Place%20de%20l'H%C3%B4tel%20de%20Ville%2C%20Saint-Bruno-de-Montarville%2C%20QC%20J3V%205Y6!5e0!3m2!1sfr!2sca!4v1700000000000!5m2!1sfr!2sca`;
  
  return (
    <div className="map-container" data-testid="google-map">
      <iframe
        src={mapSrc}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Localisation de Sourires Saint-Bruno Denturologistes"
      />
    </div>
  );
};

export default GoogleMap;
